module.exports = "pegasus/assets/themelp1/creative/100.png";